export enum ScreenType {
    Desktop,
    Tablet,
    Mobile
}

